/**
 * Build a WebSocket URL from REACT_APP_BACKEND_DEVELOPMENT_URL_SOCKET.
 *
 * Call sites here appended paths without a leading slash
 * (`${SOCKET}ws/admin_access/`), so they only worked when the env value ended
 * in one. It does not, which produced
 * "wss://dev-backend.parkingbud.comws/admin_access/" -- a hostname of
 * "dev-backend.parkingbud.comws" -- and every admin socket failed to connect.
 *
 * Normalising here means the env value works with or without a trailing slash.
 */
export const socketUrl = (path = "") => {
  const base = (process.env.REACT_APP_BACKEND_DEVELOPMENT_URL_SOCKET || "").replace(/\/+$/, "");
  const suffix = String(path).replace(/^\/+/, "");
  return suffix ? `${base}/${suffix}` : base;
};

export default socketUrl;
